import styled from 'styled-components';


export const Downloads = styled.div`
    background: var(--femaleuser);
    padding: 0.85rem 1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    box-shadow: 0rem 0.25rem 0.312rem var(--shadow);
    border-radius: 1.65rem;
`;

export const Text = styled.p`
    font-size: 0.652rem;
    font-weight: 600;
    color: var(--text);
    padding-left: 0.75rem;
`;
